import type React from 'react';
import { createContext } from 'react';

import type { Message } from '@/features/AIChat/types/chat';

export interface ChatContextValue {
  messages: Message[];
  setMessages: React.Dispatch<React.SetStateAction<Message[]>>;
  inputMessage: string;
  setInputMessage: React.Dispatch<React.SetStateAction<string>>;
  handleSend: () => void;
  sendMessage: (text: string, options?: { addHuman?: boolean }) => void;
  isInitializing: boolean;
  isSending: boolean;
  setConversationId: React.Dispatch<React.SetStateAction<string | null>>;
  conversationId: string | null;
  version: number;
  // Animated shared prompt support
  animatedHumanId?: string | null;
  animatedText?: string | null;
  onAnimatedComplete?: () => void;
}

export const ChatContext = createContext<ChatContextValue | undefined>(undefined);
